<template>
  <div>
    <div class="header">
      <div
        class="headerli"
        v-for="(item,index) in recommendList"
        :key="index"
        :class="{heightlight : recommendindex==index}"
        @click="recommendArea(index,item)"
      >
        {{item}}
        <div v-if="recommendindex==index" class="xian"></div>
      </div>
    </div>

    <div class="hometexttwo" v-if="recommendindex==0 || recommendindex==1">
      <div style="font-weight:700;font-size:16px;margin-left:20px;margin-top:10px"></div>
      <div class="hometexttwobox" v-if="documentList.length!==0">
        <div v-for="(item,index) in documentList" :key="index" class="textImgbox">
          <img
            style="margin-top:10px"
            :src="item.imgUrl"
            alt
            @click="videolearn(item.id)"
            class="imghome"
          />
          <div class="hometexttwoboxpdf">
            <div v-if="item.documentType==1">文档</div>
            <div v-else-if="item.documentType==2">视频</div>
            <div v-else-if="item.documentType==3">图片</div>
            <div v-else-if="item.documentType==4">音频</div>
            <div class="text-over" :title="item.name" @click="videolearn(item.id)">{{item.name}}</div>
          </div>
        </div>
      </div>
      <div v-else style="margin-top:20px">
        <nodata></nodata>
      </div>
      <div class="pagin-box">
        <el-pagination
          background
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChangeDocument"
          @current-change="handleCurrentChangeDocument"
          :current-page.sync="documentList.page"
          :page-size="documentList.limit"
          layout="total,prev, pager, next"
          :total="documenttotal"
          v-if="documenttotal>0"
        ></el-pagination>
      </div>
    </div>

    <div class="hometexttwo" v-if="recommendindex==2">
      <div style="font-weight:700;font-size:16px;margin-left:20px;margin-top:10px"></div>
      <div class="secondmetter" v-if="examList.length!==0">
        <div class="secondmetterheader">
          <div style="flex:3">考试名称</div>
          <div style="flex:1">考试类型</div>
          <div style="flex:1">科目</div>
          <div style="flex:1">类别</div>

          <div style="flex:2">发布单位</div>
          <div style="flex:2">发布时间</div>
        </div>
        <div v-for="(item,index) in examList " class="hover-bg" :key="index">
          <div class="secondmettertable" @click="btnTestExam(item)">
            <div style="flex:3;cursor: pointer;text-align: left;padding-left: 10px;">{{item.title}}</div>
            <div style="flex:1">
              <span v-if="item.subtype==1">练习考试</span>
              <span v-else-if="item.subtype==2">刷题模式</span>
              <span v-else-if="item.subtype==3">闯关模式</span>
            </div>
            <div style="flex:1">{{item.subjectName}}</div>
            <div style="flex:1">{{item.cateName}}</div>

            <div style="flex:2">{{item.deptName}}</div>
            <div style="flex:2">{{item.createtime}}</div>
          </div>
          <hr />
        </div>
      </div>
      <div v-else style="margin-top:20px">
        <nodata></nodata>
      </div>
      <div class="pagin-box">
        <el-pagination
          background
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChangeExam"
          @current-change="handleCurrentChangeExam"
          :current-page.sync="examList.page"
          :page-size="examList.limit"
          layout="total,prev, pager, next"
          :total="examtotal"
          v-if="examtotal"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      width="40%"
      title="准入测试内容"
      :visible.sync="innerVisible"
      :show-close="false"
      center
      append-to-body
    >
      <TestContent v-if="innerVisible" :trainId="trainId"></TestContent>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="innerVisible = false">返回</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import * as Perapi from '@/api/personcenter/index';
import TestContent from '../../train/trainclass/compoents/testContent.vue';
import { getInfo} from '@/utils/auth';
export default {
  components: {
    TestContent,
  },
  data() {
    return {
      // recommendList: ['自我推荐课程', '单位推荐课程', '推荐的练习考试'],
      recommendList: ['自我推荐课程', '单位推荐课程'],
      recommendindex: 0,

      moocList: [],
      examList: [],
      documentList: [],

      moocList: {
        page: 1,
        limit: 8,
        userId:null,
        deptId: null,
      },
      examList: {
        page: 1,
        limit: 8,
        userId: null,
      },
      documentListyy: {
        page: 1,
        limit: 8,
        userId: null,
      },
      mooctotal: 0,
      examtotal: 0,
      documenttotal: 0,
      innerVisible: false,
    };
  },
  computed: {
    getinfo() {
      return this.$store.state.User.infos;
    },
  },
  created() {
    if (this.$store.state.User.infos) {
      //判断是否登录，是的或取值，没登录取值会报错
      let list = JSON.parse(getInfo('infos'));
      this.documentListyy.userId=list.id
      this.examList.userId=list.id
      this.moocList.userId=list.id
      this.moocList.deptId=list.deptId
    } 

    this.getDocumentList();
  },
  methods: {
    recommendArea(index, item) {
      this.recommendindex = index;
      if (index == 0) {
        this.getDocumentList();
      } else if (index == 1) {
        this.CenterGetDocUnitList();
      } else if (index == 2) {
        this.getExamtList();
      }
    },
    // 单位资源
    CenterGetDocUnitList() {
      this.documentList = [];
      this.documenttotal = 0;
      Perapi.CenterGetDocUnitList(this.moocList).then((res) => {
        this.documentList = res.data;
        this.documenttotal = res.count;
      });
    },
    //点击模拟考试
    btnTestExam(row) {
      if (row.subtype == 1) {
        this.$router.push({
          path: '/simulationExam',
        });
      } else if (row.subtype == 2) {
        this.$router.push({
          path: '/BrushTopic',
        });
      } else if (row.subtype == 3) {
        this.$router.push({
          path: '/Breakthrough',
        });
      }
      localStorage.setItem('paperId', row.paperId);
      localStorage.setItem('Id', row.id);
    },

    //推送的资源
    getDocumentList() {
      this.documentList = [];
      this.documenttotal = 0;
      Perapi.getDocumentList(this.documentListyy).then((res) => {
        this.documentList = res.data;
        this.documenttotal = res.count;
      });
    },
    handleSizeChangeDocument(val) {
      this.documentList.limit = val;
      this.getDocumentList();
    },
    handleCurrentChangeDocument(val) {
      this.documentList.page = val;
      this.getDocumentList();
    },
    //推送的考试
    getExamtList() {
      let para = this.examList;
      Perapi.getExamtList(para).then((res) => {
        this.examList = res.data;
        this.examtotal = res.count;
      });
    },
    handleSizeChangeExam(val) {
      this.examList.limit = val;
      this.getList();
    },
    handleCurrentChangeExam(val) {
      this.examList.page = val;
      this.getList();
    },
    //推送的课程
    getMoocList() {
      let para = this.moocList;
      Perapi.getMoocList(para).then((res) => {
        this.list.moocList = res.data;
        this.mooctotal = res.count;
      });
    },
    handleSizeChange(val) {
      this.moocList.limit = val;
      this.getList();
    },
    newsVideo(id) {
      this.$router.push('/studyclassDetail?id=' + id);
    },
    // 跳转资源页
    videolearn(id) {
      Perapi.DocumentRead(id).then((res) => {});
      this.$router.push({
        path: '/sourceslist/videoLearn',
        query: {
          id: id,
        },
      });
    },
    handleCurrentChange(val) {
      this.moocList.page = val;
      this.getList();
    },
  },
};
</script>
<style scoped>
.text-over {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-right: 10px;
  width: 130px;
  cursor: pointer;
}
.pagin-box {
  text-align: center;
  padding: 30px 0 20px 0;
}
.homeheader {
  height: 100px;
  /* background-color: #555555; */
  display: flex;
  justify-content: space-around;
}
.homeheader > div {
  width: 200px;
  height: 76px;
  background-color: #fff;
  line-height: 76px;
  margin-top: 15px;
  border-radius: 8px;
  border: 1px solid #17b5f2;
  display: flex;
}
.homeheader > div:nth-child(1) > .text {
  margin-left: 15px;
  padding-left: 14px;
  width: 48px;
  height: 80px;
  font-family: '叶根友毛笔行书2.0版 常规', '叶根友毛笔行书2.0版';
  font-weight: 400;
  font-style: normal;
  font-size: 28px;
  background-image: url('../../../assets/personCenter/u6078.svg');
  background-repeat: no-repeat;
  background-position: 3px 12px;
}
.homeheader > div:nth-child(2) > .text {
  margin-left: 15px;
  padding-left: 14px;
  width: 48px;
  height: 80px;
  font-family: '叶根友毛笔行书2.0版 常规', '叶根友毛笔行书2.0版';
  font-weight: 400;
  font-style: normal;
  font-size: 28px;
  background-image: url('../../../assets/personCenter/u6080.svg');
  background-repeat: no-repeat;
  background-position: 3px 12px;
}
.homeheader > div:nth-child(3) > .text {
  margin-left: 15px;
  padding-left: 14px;
  width: 48px;
  height: 80px;
  font-family: '叶根友毛笔行书2.0版 常规', '叶根友毛笔行书2.0版';
  font-weight: 400;
  font-style: normal;
  font-size: 28px;
  background-image: url('../../../assets/personCenter/u6082.svg');
  background-repeat: no-repeat;
  background-position: 3px 12px;
}
.homeheader > div:nth-child(4) > .text {
  margin-left: 15px;
  padding-left: 14px;
  width: 48px;
  height: 80px;
  font-family: '叶根友毛笔行书2.0版 常规', '叶根友毛笔行书2.0版';
  font-weight: 400;
  font-style: normal;
  font-size: 28px;
  background-image: url('../../../assets/personCenter/u6084.svg');
  background-repeat: no-repeat;
  background-position: 3px 12px;
}
.homeheader > div > .bigtext {
  font-size: 28px;
}
.hometextone,
.hometexttwo {
  padding-top: 10px;
}
.hometextonebox,
.hometexttwobox {
  margin: 0 auto;
  margin-top: 10px;
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: 0 10px;
  /* justify-content: space-between; */
}
.hometexttwoboxpdf {
  display: flex;
  margin-top: 10px;
  width: 210px;
}
.hometexttwoboxpdf > div:nth-child(1) {
  margin-left: 10px;
  width: 50px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 5px;
  background-color: rgba(127, 127, 127, 1);
  color: #fff;
}
.hometexttwoboxpdf > div:nth-child(2) {
  margin-left: 10px;
}
.secondmetter {
  margin-top: 20px;
  margin: 10px 10px;
  width: 900;
  height: 320px;
  /* background-color: blue; */
}
.secondmetterheader {
  display: flex;
  font-size: 16px;
  font-weight: 400;
  height: 30px;
  background-color: rgb(50, 121, 228);
  color: #fff;
  border-radius: 10px 10px 0 0;
}
.secondmetterheader > div,
.thirdmetterheader > div {
  flex: 1;
  text-align: center;
  margin-top: 3px;
}
.secondmettertable,
.thirdmettertable {
  display: flex;
}
/* .hover-bg:hover{
  background-color: gainsboro;
} */

.secondmettertable > div {
  flex: 1;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  margin-top: 3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* 对超出的文本变成省略号，移入的时候展示出来 */
.secondmettertable > div:hover {
  overflow: auto;
  text-overflow: clip;
  white-space: normal;
}
.heightlight {
  color: #409eff !important;
}
.header {
  /* width: 850px; */
  height: 35px;
  border-bottom: solid 1px #ccc;
  padding-top: 10px;
  display: flex;
}
.header > div {
  min-width: 100px;
  text-align: center;
  line-height: 35px;
  font-size: 16px;
  cursor: pointer;
}
.header > div:hover {
  color: #409eff;
}
.xian {
  width: 90px;
  border: solid 1px #409eff;
  margin-left: 8px;
}

.textImgbox {
  margin-top: 10px;
  border: 1px solid #f2f2f2;
  border-radius: 5px;
  /* width: 210px; */
  width: calc(calc(100% / 4) - 14px);
  height: 200px;
  margin-right: 10px;
}
.imghome {
  border-radius: 5px 5px 0 0;
  height: 130px;
  cursor: pointer;
  width: 100%;
}
.textImgbox:hover {
  transform: scale(1.02);
}
.headerli {
  width: 120px;
}
</style>